
// import React from "react"; // ต้องมี React เพื่อใช้ Fragment
// import { Avatar, Form, Input, Space } from "antd";
// import { itemFormConfig } from "../../../Data/FormConfig ";

// export const FormEditAdvancedBankInfo = ({ formRef, handleSubmit, isData, confirmLoading, t }) => {
//     const channel = isData?.channel;
//     const bankId = isData?.bank?.bank_id;

//     // ค้นหา config ที่ตรงกับ channel ปัจจุบัน
//     const currentConfig = itemFormConfig.find(item => item.formChannel === channel && item.fields.find(field => field.name !== "deviceId")); // ตรวจสอบว่ามีฟิลด์ username อยู่ใน config หรือไม่

//     return (
//         <>
//             <Space className="mb-4" size={3}>
//                 <Avatar size={24} src={isData?.bank?.imageUrl} />
//                 {t(bankId)} - {isData?.accountNumber} - {isData?.accountName}
//             </Space>

//             <Form
//                 ref={formRef}
//                 name="edit_advanced_data_form"
//                 onFinish={handleSubmit}
//                 layout="vertical"
//                 initialValues={{
//                     // Mapping key ให้ตรงกับโครงสร้าง Input name
//                     username: isData?.username,
//                     password: isData?.password,
//                     companyId: isData?.company_id || isData?.companyId,
//                     // deviceId: isData?.deviceId,
//                     pin: isData?.pin,
//                     accountRefId: isData?.accountRefId,
//                     visitorId: isData?.visitor_id || isData?.visitorId,
//                     visitorKey: isData?.visitor_key || isData?.visitorKey,
//                     note: isData?.note || "",
//                 }}
//             >
//                 {currentConfig?.fields.map((field, index) => (
//                     <Form.Item
//                         key={`${channel}-${field.name}-${index}`}
//                         name={field.name}
//                         label={field.label}
//                     >
//                         {field.type === "password" ? (
//                             <Input.Password placeholder={`Enter ${field.label}`} disabled={confirmLoading} />
//                         ) : (
//                             <Input placeholder={`Enter ${field.label}`} disabled={confirmLoading} />
//                         )}
//                     </Form.Item>
//                 ))}

//                 <Form.Item name="note" label={t('note')}>
//                     <Input.TextArea
//                         disabled={confirmLoading}
//                         rows={3}
//                         placeholder={t('Enter note here')}
//                     />
//                 </Form.Item>
//             </Form>
//         </>
//     );
// };

import { Avatar, Form, Input, Space } from "antd";
import { itemFormConfig } from "../../../Data/FormConfig ";

export const FormEditAdvancedBankInfo = ({ formRef, handleSubmit, isData, confirmLoading, t }) => {
    const channel = isData?.channel;
    const bankId = isData?.bank?.bank_id;

    // 1. ค้นหา Config ตาม channel ตรงๆ
    const targetConfig = itemFormConfig.find(item => item.formChannel === channel);

    // 2. กรอง fields โดยยกเว้น deviceId ออกอย่างถูกต้อง
    const renderFields = targetConfig?.fields?.filter(field => field.name !== "deviceId") || [];

    return (
        <>
            <Space className="mb-4" size={3}>
                <Avatar size={24} src={isData?.bank?.imageUrl} />
                {t(bankId)} - {isData?.accountNumber} - {isData?.accountName}
            </Space>

            <Form
                ref={formRef}
                name="edit_advanced_data_form"
                onFinish={handleSubmit}
                layout="vertical"
                initialValues={{
                    username: isData?.username,
                    password: isData?.password,
                    companyId: isData?.company_id || isData?.companyId,
                    pin: isData?.pin,
                    accountRefId: isData?.accountRefId,
                    visitorId: isData?.visitor_id || isData?.visitorId,
                    visitorKey: isData?.visitor_key || isData?.visitorKey,
                    note: isData?.note || "",
                }}
            >
                {/* 3. ลูปเรนเดอร์ Field จากรายการที่กรองแล้ว */}
                {renderFields.map((field) => (
                    <Form.Item
                        key={`${channel}-${field.name}`}
                        name={field.name}
                        label={field.label}
                    >
                        {field.type === "password" ? (
                            <Input.Password placeholder={`Enter ${field.label}`} disabled={confirmLoading} />
                        ) : (
                            <Input placeholder={`Enter ${field.label}`} disabled={confirmLoading} />
                        )}
                    </Form.Item>
                ))}

                <Form.Item name="note" label={t('note')}>
                    <Input.TextArea
                        disabled={confirmLoading}
                        rows={3}
                        placeholder={t('Enter note here')}
                    />
                </Form.Item>
            </Form>
        </>
    );
};